"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { RelativeTimeSuffix } from "@/components/domain/relative-time-suffix";
import { useHydratedNow } from "@/hooks/use-hydrated-now";
import { cn } from "@domainstack/ui/utils";
import { formatRelativeTime, toDateTimeAttr } from "@domainstack/utils/date";
import { calculateDaysRemaining } from "@domainstack/utils/expiry";
export function RelativeExpiryString(t0) {
  const $ = _c(17);
  const {
    to,
    dangerDays: t1,
    warnDays: t2,
    className
  } = t0;
  const dangerDays = t1 === undefined ? 7 : t1;
  const warnDays = t2 === undefined ? 14 : t2;
  const now = useHydratedNow();
  let t3;
  if ($[0] !== to) {
    t3 = toDateTimeAttr(to);
    $[0] = to;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const dateTime = t3;
  let t4;
  bb0: {
    if (!now || !dateTime) {
      t4 = null;
      break bb0;
    }
    let t5;
    let t6;
    if ($[2] !== dateTime || $[3] !== now) {
      const targetDate = new Date(dateTime);
      t5 = formatRelativeTime(targetDate, now);
      t6 = calculateDaysRemaining(targetDate, now);
      $[2] = dateTime;
      $[3] = now;
      $[4] = t5;
      $[5] = t6;
    } else {
      t5 = $[4];
      t6 = $[5];
    }
    let t7;
    if ($[6] !== t5 || $[7] !== t6) {
      t7 = {
        text: t5,
        daysUntil: t6
      };
      $[6] = t5;
      $[7] = t6;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    t4 = t7;
  }
  const state = t4;
  const t5 = state?.text ?? null;
  const t6 = state && state.daysUntil <= dangerDays && "text-red-600 dark:text-red-400";
  const t7 = state && state.daysUntil > dangerDays && state.daysUntil <= warnDays && "text-amber-600 dark:text-amber-400";
  let t8;
  if ($[9] !== className || $[10] !== t6 || $[11] !== t7) {
    t8 = cn(t6, t7, className);
    $[9] = className;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== dateTime || $[14] !== t5 || $[15] !== t8) {
    t9 = <RelativeTimeSuffix dateTime={dateTime} text={t5} className={t8} />;
    $[13] = dateTime;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}